import React from 'react';
import { Link } from 'react-router-dom';

export function ApplyNavbar() {
  return (
    <>
      <div className="page-glow glow-1" />
      <div className="page-glow glow-2" />
      <div className="page-glow glow-3" />

      <header className="nav">
        <div className="container nav-inner">
          <Link className="brand" to="/apply">
            <div className="logo" />
            <div>
              <strong>祖孙同唱健康歌</strong>
              <span>全国首届祖孙隔代歌唱大赛</span>
            </div>
          </Link>
          <nav className="nav-links">
            <a href="/apply#about">赛事介绍</a>
            <a href="/apply#schedule">赛程规划</a>
            <a href="/apply#awards">奖励设置</a>
            <Link to="/apply/register">立即报名</Link>
          </nav>
          <Link className="nav-cta" to="/apply/register">我要参赛</Link>
        </div>
      </header>
    </>
  );
}